import React from 'react';
import { BookOpenIcon, FileTextIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const highlights = [{
  icon: BookOpenIcon,
  label: '6 Volumes'
}, {
  icon: GiftIcon,
  label: '5 Bonuses'
}, {
  icon: FileTextIcon,
  label: '800+ Pages'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}];
export function Hero() {
  return <section className="w-full bg-navy px-5 pb-8 pt-6 sm:pb-14 sm:pt-12" data-id="element-101" data-mp="4jvvvb7dj8w9">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-102" data-mp="128z0cez35zzp">
        <span className="mb-4 inline-block rounded-full border border-gold bg-gold/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-gold sm:mb-6" data-id="element-103" data-mp="xbfi73z9p32h">
          For Visual Arts Teachers
        </span>
        <h1 className="font-display text-[24px] font-bold leading-tight text-white sm:text-5xl md:text-6xl" data-id="element-104" data-mp="nbosrgpkde99">
          Your Entire Art Year—Organized and Ready to Teach.
        </h1>
        <figure className="relative -mx-5 mt-5 w-[calc(100%+2.5rem)] max-w-none sm:mx-0 sm:mt-8 sm:w-full sm:max-w-[820px]" data-id="element-105" data-mp="381nuv9jxgt3y">
          <img src="https://cdn.magicpatterns.com/uploads/3VM9QSnbqTVkpSnstYUGxA/complete-art-year-hero-bundle-1600.webp" alt="THE COMPLETE ART YEAR product box with the six core volumes and five teacher bonuses, shown in a bright art classroom" width="1600" height="893" sizes="(max-width: 639px) 100vw, 820px" fetchPriority="high" loading="eager" decoding="async" className="block aspect-[1600/893] h-auto w-full object-contain" style={{
          maskImage: 'linear-gradient(to right, transparent 0%, #000 5%, #000 95%, transparent 100%), linear-gradient(to bottom, transparent 0%, #000 6%, #000 94%, transparent 100%)',
          WebkitMaskImage: 'linear-gradient(to right, transparent 0%, #000 5%, #000 95%, transparent 100%), linear-gradient(to bottom, transparent 0%, #000 6%, #000 94%, transparent 100%)',
          maskComposite: 'intersect',
          WebkitMaskComposite: 'source-in'
        }} data-id="element-106" data-mp="3j6fy7px5bddu" />
        </figure>
        <p className="mt-4 max-w-xl text-[13px] leading-relaxed text-white/75 sm:mt-6 sm:text-base" data-id="element-107" data-mp="s21iocxnug0i">
          A complete visual teaching system with lessons, activities, creative projects, art history,
          assessment tools and classroom resources—all designed to help you spend less time building
          everything from scratch.
        </p>
        <p className="mt-3 text-[13px] font-semibold text-white sm:mt-4 sm:text-base" data-id="element-108" data-mp="degcub9ei2ow">
          6 Core Teaching Volumes + 5 Professional Teacher Bonuses
        </p>
        <div className="mt-5 w-full max-w-md sm:mt-7" data-id="element-109" data-mp="161az9dps3c50">
          <CTAButton label="GET THE COMPLETE ART YEAR™" data-id="element-110" data-mp="15zq35jntfl51" />
          <p className="mt-3 text-xs text-white/65 sm:text-sm" data-id="element-111" data-mp="111okgzuaxnu3">
            One-Time Payment · No Subscription · Instant Digital Access · Lifetime Access
          </p>
          <p className="mt-2 text-xs font-medium text-gold" data-id="element-112" data-mp="3lsypkqaae6eu">
            Elementary · Middle School · High School
          </p>
        </div>
        <ul className="mt-5 flex items-center justify-center gap-1.5 whitespace-nowrap text-[11.5px] text-white/85 min-[400px]:gap-2 min-[400px]:text-[13px] sm:mt-6 sm:text-sm" data-id="element-113" data-mp="3hqk9uf1wzmrs">
          {highlights.map(({
          icon: Icon,
          label
        }, index) => <li key={label} className="flex items-center gap-1.5 min-[400px]:gap-2" data-id="element-114" data-mp="218tntq0zt0c8" data-mpi={index}>
              {index > 0 && <span className="text-gold/60" aria-hidden="true" data-id="element-115" data-mp="267whkebivk4w">·</span>}
              <Icon className="h-3.5 w-3.5 shrink-0 text-gold" aria-hidden="true" data-id="element-116" data-mp="2b1hj2gcbqw8u" />
              <span data-id="element-117" data-mp="2fyr5ro8bwtsz">{label}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}